import React from "react";
import classes from "./ClosedQuestion.module.scss";

type ClosedQuestionProps = {
  /** 質問番号 */
  questionNumber: number;
  /** 質問文 */
  questionText: string;
  /** 選択肢リスト */
  choices: string[];
  /** 回答リスト */
  answers: number[];
  /** 回答が必須かどうか */
  require: boolean;
  /** 複数選択できるか */
  multiple: boolean;
  /** 選択肢を選択した際の処理 */
  onChange: (answer: number) => void;
};

/**
 * 回答選択式設問モジュール
 */
const ClosedQuestion: React.FC<ClosedQuestionProps> = (props) => {
  const questionType = `${
    props.multiple ? "当てはまるものを全て選択" : "当てはまるものを一つ選択"
  } ${props.require ? "/ 回答必須" : ""}`;

  return (
    <div className="w-100">
      <div className="mb-2 mb-sm-3">
        <ol
          start={props.questionNumber}
          className={`mb-1 ${classes.questionText}`}
        >
          <li>{props.questionText}</li>
        </ol>
        <div className={classes.hintBody}>
          <span className={`px-1 px-sm-3 py-sm-1 ${classes.hintText}`}>
            {questionType}
          </span>
        </div>
      </div>
      <div className={classes.contents}>
        {props.multiple ? (
          // 複数選択型設問の場合
          <div>
            {props.choices.map((c, i) => {
              return (
                <div
                  className={`${classes.inputForm} d-flex align-items-center`}
                  key={`Q${props.questionNumber}_${i}`}
                >
                  <label className="mb-1">
                    <input
                      className="mr-1"
                      type="checkbox"
                      name={`Q${props.questionNumber}_${i}`}
                      value={i}
                      checked={props.answers.includes(i)}
                      onChange={() => props.onChange(i)}
                    />
                    {c}
                  </label>
                </div>
              );
            })}
          </div>
        ) : (
          // 単一選択型設問の場合
          <div>
            {props.choices.map((c, i) => {
              return (
                <div
                  className={`${classes.inputForm} d-flex align-items-center`}
                  key={`Q${props.questionNumber}_${i}`}
                >
                  <label className="mb-1">
                    <input
                      className="mr-1"
                      type="radio"
                      name={`Q${props.questionNumber}_${i}`}
                      value={i}
                      checked={props.answers.includes(i)}
                      onChange={() => props.onChange(i)}
                    />
                    {c}
                  </label>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClosedQuestion;
